import { storage } from '@services/storageService'

const extractFileNameFromResponse = response => {
  const attachFile = response?.headers?.get('Content-Disposition') ?? null
  return attachFile ? attachFile?.split('filename=')[1]?.split(';')[0] : ''
}

/**
 * Get file URL and downlaod the files
 * @param {string} fileURL
 * @param {string} fileName
 * @param {string} sessionUrl
 * @param {object} data
 * @param {string} httpMethod
 */
export const downloadFile = async (
  fileURL,
  fileName?,
  sessionUrl?,
  data?,
  httpMethod?
) => {
  let downloadFileName = ''
  return await fetchFileAPI(fileURL, sessionUrl, data, httpMethod)
    .then(response => {
      downloadFileName = fileName ? fileName : extractFileNameFromResponse(response)
      if (response.status !== 200) {
        return response.json()
      }
      return response.blob()
    })
    .then(response => {
      if (response && response.error) {
        return response
      }
      var url = window.URL.createObjectURL(response)
      var a = document.createElement('a')
      a.href = url
      a.download = downloadFileName
      a.click()
      a.remove()
      setTimeout(() => window.URL.revokeObjectURL(url), 100)
      return {
        error: false,
        statusCode: 200
      }
    })
}

export const fetchFileAPI = async (fileURL, sessionUrl?, data?, httpMethod?) =>
  await fetch(fileURL, {
    method: httpMethod,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: sessionUrl || `Bearer ${storage.getItem<string>('access_token')}`,
      mode: 'no-cors'
    },
    body: JSON.stringify(data)
  })
